module.exports = __webpack_public_path__ + "img/rabbit.be5030ca.webp";